import DataHexagon from '@backrs_ui/common-ui/src/assets/images/data-hexagon.svg';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const BACKRS_APP_URL = process.env.REACT_APP_BACKRS_URL;

const DATA_LOCKED_AND_LOADED_STRINGS =
  appStrings.modules.home.sections.completeYourProfile.dataLockedAndLoaded;

const PROFILE_CHECKLIST_STRINGS =
  appStrings.modules.home.sections.completeYourProfile.profileChecklist;

export const DATA_LOCKED_AND_LOADED_SECTION = {
  title: DATA_LOCKED_AND_LOADED_STRINGS.title,
  description: DATA_LOCKED_AND_LOADED_STRINGS.description,
  imageUrl: DataHexagon,
  checkboxItems: [...DATA_LOCKED_AND_LOADED_STRINGS.checkboxItems],
};

export const PROFILE_CHECKLIST_SECTION = {
  title: PROFILE_CHECKLIST_STRINGS.title,
  checklistItems: [
    {
      title: PROFILE_CHECKLIST_STRINGS.checklistItems.profilePicture.title,
      description: PROFILE_CHECKLIST_STRINGS.checklistItems.profilePicture.description,
      onClick: () => window.open(`${BACKRS_APP_URL}/wholeme/wizard/identity/photo/true`, '_blank'),
    },
    {
      title: PROFILE_CHECKLIST_STRINGS.checklistItems.introVideo.title,
      description: PROFILE_CHECKLIST_STRINGS.checklistItems.introVideo.description,
      onClick: () =>
        window.open(`${BACKRS_APP_URL}/wholeme/wizard/identity/purpose_video/true`, '_blank'),
    },
    {
      title: PROFILE_CHECKLIST_STRINGS.checklistItems.uploadDocuments.title,
      description: PROFILE_CHECKLIST_STRINGS.checklistItems.uploadDocuments.description,
      onClick: () => window.open(`${BACKRS_APP_URL}/tabs/profile?mode=story`, '_blank'),
    },
    {
      title: PROFILE_CHECKLIST_STRINGS.checklistItems.profileDetails.title,
      description: PROFILE_CHECKLIST_STRINGS.checklistItems.profileDetails.description,
      onClick: () => window.open(`${BACKRS_APP_URL}/wholeme/portrait`, '_blank'),
    },
    {
      title: PROFILE_CHECKLIST_STRINGS.checklistItems.socialCapitalQuiz.title,
      description: PROFILE_CHECKLIST_STRINGS.checklistItems.socialCapitalQuiz.description,
      onClick: () => window.open(`${BACKRS_APP_URL}/wholeme/wizard/network/network`, '_blank'),
    },
  ],
};
